export const COUNTRY_COORDINATES = {
  Poland: { center: { lat: 52.1, lng: 19.280556 }, zoom: 6.8 },
  Qatar: { center: { lat: 25.3548, lng: 51.1839 }, zoom: 9 },
  Austria: { center: { lat: 47.5162, lng: 14.5501 }, zoom: 7 },
  Denmark: { center: { lat: 56.155278, lng: 10.198778 }, zoom: 7 },
  Ghana: { center: { lat: 8.0, lng: -1.0 }, zoom: 7 },
  India: { center: { lat: 20.59, lng: 78.96 }, zoom: 5 },
  France: { center: { lat: 46.22, lng: 2.21 }, zoom: 6 },
} as const;

export type CountryKey = keyof typeof COUNTRY_COORDINATES; 